export const API_PATH = 'auth/login'
